<script setup>
import { computed, watch } from 'vue'
import { useUserStore } from '@/stores/user'
import { useChatStore } from '@/stores/chat'
import { debounce } from 'radash'

const userStore = useUserStore()
const chatStore = useChatStore()

const defaultStatusTimeout = computed(() => {
  return userStore.features.userStatus?.defaultStatusTimeout || 5
})

const partnerChatStatus = computed(() => chatStore.partnerChatStatus)

const updateStatusToLeftChat = debounce({ delay: 1000 * defaultStatusTimeout.value }, () => {
  if (chatStore.partnerChatStatus) {
    chatStore.partnerChatStatus = {
      ...chatStore.partnerChatStatus,
      status: 'left_chat'
    }
  }
})

watch(() => partnerChatStatus.value?.id, (id) => {
  if (id) {
    updateStatusToLeftChat()
  }
}, { immediate: true })
</script>

<template>
  <template v-if="partnerChatStatus">
    <div
      v-if="partnerChatStatus.status === 'typing'"
      class="text-xs flex items-center gap-1 text-blue-600 whitespace-nowrap">
      <InlineSvg
        :src="require('@/assets/fontawesome/regular/pen.svg')"
        class="h-3 w-3 shrink-0"/>

      {{ $t('chat.is_typing') }}

      <div class="wave">
        <span class="dot"/>
        <span class="dot"/>
        <span class="dot"/>
      </div>
    </div>
    <!--
    <div
      v-else-if="partnerChatStatus.status === 'entered_chat'"
      class="text-xs flex items-center gap-1 text-gray-900 whitespace-nowrap">
      <span class="rounded-full w-2 h-2 shrink-0 bg-blue-600"/>

      In chat
    </div>

    <div
      v-else
      class="text-xs flex items-center gap-1 text-gray-500 whitespace-nowrap">
      <span class="rounded-full w-2 h-2 shrink-0 bg-gray-300"/>

      Left chat
    </div>
    -->
  </template>
</template>

<style scoped>
  .wave {
    position: relative;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .wave .dot {
    display: inline-block;
    width: 3px;
    height: 3px;
    border-radius: 50%;
    margin-right: 2px;
    background: #2563eb;
    animation: wave 1.3s linear infinite;
  }

  .wave .dot:nth-child(2) {
    animation-delay: -1.1s;
  }

  .wave .dot:nth-child(3) {
    animation-delay: -0.9s;
  }

  @keyframes wave {
    0%, 60%, 100% {
      transform: initial;
    }
    30% {
      transform: translateY(-5px);
    }
  }
</style>
